// Tipos de bloco que o usuário pode inserir na proposta / modelo.
// `dynamic: true` = bloco preenchido automaticamente com dados do CRM (não tem rich text).
// `unique: true` = só pode existir um por documento (ex.: tabela de itens).
export const BLOCK_TYPES = [
  { tipo: 'texto', label: 'Texto livre', icon: 'mdi:format-text', descricao: 'Parágrafo formatado', dynamic: false },
  { tipo: 'data', label: 'Data', icon: 'mdi:calendar-outline', descricao: 'Data da proposta', dynamic: true },
  { tipo: 'validade', label: 'Validade', icon: 'mdi:calendar-clock-outline', descricao: 'Prazo de validade', dynamic: true },
  { tipo: 'dados_cliente', label: 'Dados do cliente', icon: 'mdi:account-outline', descricao: 'Nome, e-mail e telefone', dynamic: true },
  { tipo: 'itens', label: 'Itens do orçamento', icon: 'mdi:table-large', descricao: 'Tabela de produtos/serviços', dynamic: true, unique: true },
  { tipo: 'forma_pagamento', label: 'Forma de pagamento', icon: 'mdi:credit-card-outline', descricao: 'Condições de pagamento', dynamic: false },
  { tipo: 'observacoes', label: 'Observações', icon: 'mdi:note-text-outline', descricao: 'Observações gerais', dynamic: false },
];

// Aliases dos tipos legados para o renderizador de texto.
const LEGACY_TEXT_TYPES = ['custom', 'apresentacao', 'escopo', 'condicoes', 'capa'];

export const BLOCK_TYPE_MAP = BLOCK_TYPES.reduce((acc, b) => { acc[b.tipo] = b; return acc; }, {});

export function getBlockMeta(tipo) {
  if (BLOCK_TYPE_MAP[tipo]) return BLOCK_TYPE_MAP[tipo];
  if (tipo === 'tabela_precos') return BLOCK_TYPE_MAP.itens;
  if (LEGACY_TEXT_TYPES.includes(tipo)) return BLOCK_TYPE_MAP.texto;
  return BLOCK_TYPE_MAP.texto;
}

export function isTextoBloco(tipo) {
  return getBlockMeta(tipo).dynamic === false;
}

export function novoBloco(tipo, ordem) {
  const base = { tipo, titulo: '', conteudo_html: '', config: {}, ordem };
  if (tipo === 'forma_pagamento') base.titulo = 'Forma de pagamento';
  if (tipo === 'observacoes') base.titulo = 'Observações';
  if (tipo === 'data') base.config = { cidade: '' };
  return base;
}
